import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlytransportationserviceinpune() {



  const cardData =
  {
    keyword: ' Monthly Transportation Services in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Monthly Transportation Services in Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional Monthly Transportation Services in Pune, catering to the recurring travel requirements of corporate offices, IT companies, manufacturing units, and business parks. Our fleet of well-maintained sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, supervisors, clients, and senior executives. Whether it is daily employee commute, scheduled office routes, airport transfers, or executive movement, we deliver structured and hassle-free mobility solutions. With trained chauffeurs, transparent monthly rental plans, and dedicated service support, Pune Corporate Cars India Private Limited ensures a smooth and cost-effective transportation experience for businesses operating in Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
{
"name": "Monthly Shuttle Service Pune",
"description": "Monthly Shuttle Service Pune provides large-scale employee shuttle solutions on a fixed monthly plan. The service ensures daily, punctual, and safe transportation for office staff, IT park employees, and factory workers. With GPS-enabled vehicles, trained drivers, and structured multi-shift operations, companies can streamline workforce mobility, reduce administrative workload, and guarantee reliable transportation throughout the month."
},
{
"name": "Employee Monthly Commute Pune",
"description": "Employee Monthly Commute Pune delivers comprehensive long-term commute solutions for corporate employees. The service offers dedicated vehicles, consistent daily schedules, and well-planned routes to ensure timely pickups and drops. It reduces travel stress, enhances workforce productivity, and provides a comfortable, secure, and organized commuting experience for employees across Pune."
},
{
"name": "Monthly Staff Pick Drop Pune",
"description": "Monthly Staff Pick Drop Pune specializes in structured daily transportation for office and industrial staff under a fixed monthly plan. The service provides reliable routing, multi-shift support, professional drivers, and GPS tracking, ensuring safe and punctual commute while optimizing travel operations for companies and minimizing employee waiting times."
},
{
"name": "Monthly Company Cab Pune",
"description": "Monthly Company Cab Pune offers long-term corporate cab solutions tailored for employee commute needs. With dedicated sedans, SUVs, and staff cabs, the service ensures consistent availability, on-time pickups, and safe travel. Companies benefit from fixed monthly packages, operational efficiency, and hassle-free management of employee transportation."
},
{
"name": "Corporate Monthly Fleet Pune",
"description": "Corporate Monthly Fleet Pune provides businesses with a dedicated fleet for employee transportation on monthly plans. The service includes fleet management, driver scheduling, GPS tracking, and route optimization to ensure reliable, comfortable, and efficient commuting for large groups of employees across multiple shifts and locations."
},
{
"name": "Affordable Monthly Transport Pune",
"description": "Affordable Monthly Transport Pune delivers cost-effective long-term transportation solutions for employees. The service balances affordability with reliability, offering well-maintained vehicles, trained drivers, and consistent service schedules. It is ideal for startups, small offices, and large corporates seeking budget-friendly, monthly commuting options for staff."
},
{
"name": "Monthly Office Travel Pune",
"description": "Monthly Office Travel Pune ensures structured daily transportation for office employees under fixed monthly plans. The service features scheduled pickups and drops, professional drivers, and secure vehicles, making it easier for companies to manage large workforce commuting efficiently while providing employees with a smooth and convenient travel experience."
},
{
"name": "Best Monthly Employee Shuttle",
"description": "Best Monthly Employee Shuttle delivers premium shuttle services for employees with a focus on comfort, safety, and punctuality. The service includes minibuses and vans with structured routing, multi-shift support, and GPS tracking, providing companies with reliable and high-quality monthly commuting solutions for their workforce."
},
{
"name": "Monthly Sedan Cab Pune",
"description": "Monthly Sedan Cab Pune provides premium sedan vehicles for executives, managers, and corporate staff on long-term monthly plans. The service ensures timely pickups, comfortable rides, professional drivers, and well-maintained vehicles, making it ideal for office travel, business trips, and VIP commutes within Pune."
},
{
"name": "Monthly SUV Cab Pune",
"description": "Monthly SUV Cab Pune offers spacious and comfortable SUVs for group travel, team commuting, and long-distance corporate trips under a monthly plan. The service prioritizes safety, punctuality, and convenience, catering to employees, managers, and visiting clients needing larger vehicles for regular transportation."
},
{
"name": "Monthly Chauffeur Car Pune",
"description": "Monthly Chauffeur Car Pune provides executive car services with professional drivers for employees, managers, and VIP clients. With fixed monthly packages, the service ensures punctuality, safety, comfort, and reliable transportation for daily office commutes, client visits, and business travel within Pune and surrounding areas."
},
{
"name": "Monthly Business Cab Hire Pune",
"description": "Monthly Business Cab Hire Pune delivers long-term corporate taxi solutions for employees and executives. The service features flexible monthly plans, GPS-enabled sedans and SUVs, trained drivers, and route optimization, ensuring hassle-free, efficient, and safe commuting for businesses of all sizes."
},
{
"name": "Worker Transportation Monthly Pune",
"description": "Worker Transportation Monthly Pune specializes in monthly transportation for factory and industrial workers. The service provides structured pickups and drops, shift-based scheduling, safe vehicles, and professional drivers, ensuring timely, reliable, and organized transport for large-scale workforce operations."
},
{
"name": "Corporate Staff Commute Monthly Pune",
"description": "Corporate Staff Commute Monthly Pune offers fixed monthly plans for employee commuting. The service ensures daily, reliable, and secure transportation for staff, supporting multiple shifts, structured routes, and GPS tracking. Companies benefit from optimized operations, reduced management effort, and improved employee satisfaction."
},
{
"name": "Office Employee Monthly Mobility Pune",
"description": "Office Employee Monthly Mobility Pune provides end-to-end monthly transportation solutions for corporate employees. The service includes sedans, SUVs, and shuttle vans with trained drivers, GPS monitoring, and consistent scheduling. It ensures comfortable, safe, and punctual commuting for employees, enhancing workforce efficiency and operational convenience."
}
],

"tableData": [
["Monthly Shuttle Service Pune", "Employee Monthly Commute Pune"],
["Monthly Staff Pick Drop Pune", "Monthly Company Cab Pune"],
["Corporate Monthly Fleet Pune", "Affordable Monthly Transport Pune"],
["Monthly Office Travel Pune", "Best Monthly Employee Shuttle"],
["Monthly Sedan Cab Pune", "Monthly SUV Cab Pune"],
["Monthly Chauffeur Car Pune", "Monthly Business Cab Hire Pune"],
["Worker Transportation Monthly Pune", "Corporate Staff Commute Monthly Pune"],
["Office Employee Monthly Mobility Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Monthly Transportation Services in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable monthly transportation services for businesses, ensuring consistent and hassle-free commuting for employees across Pune."
  },
  {
    "WhyChooseheading": "Flexible Monthly Travel Plans",
    "WhyChoosedescription": "We provide customizable monthly transportation packages tailored to suit the commuting needs of employees and corporate teams."
  },
  {
    "WhyChooseheading": "Professional & Trained Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs ensure safe, punctual, and comfortable rides for employees throughout the month."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—well-maintained, sanitized, and designed for comfortable daily commuting."
  },
  {
    "WhyChooseheading": "Punctual & Reliable Service",
    "WhyChoosedescription": "Our monthly transportation services guarantee timely pickups and drops, providing smooth and dependable travel for your workforce."
  },
  {
    "WhyChooseheading": "24/7 Support for Employees",
    "WhyChoosedescription": "We offer round-the-clock assistance for scheduling changes, emergencies, and route adjustments, ensuring uninterrupted monthly transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Travel",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features to provide secure and clean commuting for employees."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Our streamlined booking process and reliable coordination make managing monthly transportation simple and stress-free for businesses."
  }
]



























  }

const faqData = [
  {
    question: 'Do you provide monthly transportation services in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers flexible and reliable monthly transportation services for corporate clients and employees in Pune.',
  },
  {
    question: 'What type of vehicles are available for monthly transportation services?',
    answer: 'We provide hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers based on company requirements and employee strength.',
  },
  {
    question: 'How can companies book monthly transportation services?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Do you offer customized monthly transport plans for corporate clients?',
    answer: 'Yes, we create tailored monthly transport solutions depending on staff size, routes, and shift timings.',
  },
  {
    question: 'Are chauffeurs provided with monthly transportation services?',
    answer: 'Absolutely. All vehicles come with trained, professional, and uniformed chauffeurs for corporate travel.',
  },
  {
    question: 'Can companies avail long-term monthly transportation contracts?',
    answer: 'Yes, we offer flexible monthly, quarterly, and annual contracts with transparent pricing.',
  },
  {
    question: 'Do you provide airport pickup and drop services as part of monthly plans?',
    answer: 'Yes, airport transfers can be included in your monthly corporate transport plans.',
  },
  {
    question: 'What safety measures are followed for monthly transportation services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by verified and trained chauffeurs to ensure employee safety.',
  },
  {
    question: 'What payment options are available for monthly transportation services?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and offer corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ritesh More',
    feedback: 'Our monthly transportation requirements in Pune are handled perfectly by Pune Corporate Cars India Private Limited. Punctual, professional, and reliable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Patil',
    feedback: 'Very efficient monthly transport service. Our employees enjoy hassle-free and timely commute every day.',
    rating: 5,
  },
];





















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Transportation Services in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/monthly-transportation-pune.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited provides reliable monthly transportation services in Pune, including employee shuttles, staff pick-up and drop, corporate monthly fleets, and chauffeur-driven sedans and SUVs. Designed for companies to ensure smooth, safe, and timely monthly commute for employees.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "4700", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/monthly-transportation-services-pune"
  }
};





  return (
    <div>
<Helmet>
  <title>Monthly Transportation Services in Pune | Employee & Corporate Monthly Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited provides reliable monthly transportation services in Pune, including employee shuttles, staff pick-up and drop, corporate monthly fleets, and chauffeur-driven sedans and SUVs. Designed for companies to ensure smooth, safe, and timely monthly commute for employees."
  />

  <meta
    name="keywords"
    content="Monthly Shuttle Service Pune, Employee Monthly Commute Pune, Monthly Staff Pick Drop Pune, Monthly Company Cab Pune, Corporate Monthly Fleet Pune, Affordable Monthly Transport Pune, Monthly Office Travel Pune, Best Monthly Employee Shuttle, Monthly Sedan Cab Pune, Monthly SUV Cab Pune, Monthly Chauffeur Car Pune, Monthly Business Cab Hire Pune, Worker Transportation Monthly Pune, Corporate Staff Commute Monthly Pune, Office Employee Monthly Mobility Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlytransportationserviceinpune;